"use client";

import { HydratedApp, useApp } from "@zapier/client";
import { AppDetailsHeader } from "./AppDetailsHeader";
import { AppDetailsConnections } from "./AppDetailsConnections";
import { PageSizeProvider } from "@zapier/shared";
import { useConnectionModalStates } from "../connections/useConnectionModalStates";
import { ConnectionModals } from "../connections/ConnectionModals";
interface Props {
  serviceSlug?: string; // will come from public app details pages
  selectedApi?: string; // will come from private app details pages
}

export function AppDetails({ serviceSlug, selectedApi }: Props) {
  const { app, isLoading } = useApp({
    slug: serviceSlug,
    selectedApi: selectedApi || "",
    includeImplementation: true,
  });

  const {
    currentConnection,
    currentConnectionModal,
    setCurrentConnection,
    setCurrentConnectionModal,
  } = useConnectionModalStates();

  return (
    <PageSizeProvider>
      <AppDetailsHeader
        app={app as unknown as HydratedApp}
        isPrivate={!!selectedApi}
        slug={serviceSlug}
        selectedApi={selectedApi}
        serviceSlug={serviceSlug}
        isLoading={isLoading}
      />

      <AppDetailsConnections
        title="Personal connections"
        type="personal"
        serviceSlug={serviceSlug}
        selectedApi={selectedApi}
        currentConnection={currentConnection}
        currentConnectionModal={currentConnectionModal}
        setCurrentConnection={setCurrentConnection}
        setCurrentConnectionModal={setCurrentConnectionModal}
      />
      <AppDetailsConnections
        title="Shared connections"
        type="shared"
        serviceSlug={serviceSlug}
        selectedApi={selectedApi}
        currentConnection={currentConnection}
        currentConnectionModal={currentConnectionModal}
        setCurrentConnection={setCurrentConnection}
        setCurrentConnectionModal={setCurrentConnectionModal}
      />
      <AppDetailsConnections
        title="Private connections"
        type="private"
        serviceSlug={serviceSlug}
        selectedApi={selectedApi}
        currentConnection={currentConnection}
        currentConnectionModal={currentConnectionModal}
        setCurrentConnection={setCurrentConnection}
        setCurrentConnectionModal={setCurrentConnectionModal}
      />

      <ConnectionModals
        currentModal={currentConnectionModal}
        setCurrentModal={setCurrentConnectionModal}
        setCurrentConnection={setCurrentConnection}
        currentConnections={currentConnection ? [currentConnection] : []}
      />
    </PageSizeProvider>
  );
}
